import { SliderPlatforms } from 'shared/models/Slider'

const regexp = new RegExp(/[a-z]|\d/)

export const getProjectSlug = () => {
  const hostName = window.location.hostname === 'localhost' ? 'evobet216.com' : window.location.hostname
  const hostNameSplitted = hostName.split('.')
  const hostNamePure =
    hostNameSplitted.length > 2
      ? `${hostNameSplitted[hostNameSplitted.length - 2]}.${hostNameSplitted[hostNameSplitted.length - 1]}`
      : hostName
  const slug = hostNamePure
    .split('')
    .map(char => (char.match(regexp) ? char : ''))
    .join('')

  return slug
}

export const getCarouselParameters = (carouselSlug: string): { language: string; platform: SliderPlatforms } => {
  const carouselSlugSplited = carouselSlug.split('^')

  return {
    language: carouselSlugSplited.find(item => item.startsWith('lg:'))?.replace('lg:', '') || '',
    platform:
      (carouselSlugSplited.find(item => item.startsWith('pt:'))?.replace('pt:', '') as SliderPlatforms) ||
      SliderPlatforms.NOT_FOUND,
  }
}
